<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <!-- <v-flex xs12 sm6 md2>
           <v-text-field @keyup.enter="search_client_by_code"  v-model="searchClientCode" label="كودالعميل"  ></v-text-field>
            </v-flex> 
             <v-flex xs12 sm6 md4>
                    <v-select
                    v-model="select_client"
                    :items="clients"
                    item-text="name"
                    item-value="id"
                    label="أختر العميل"
                    persistent-hint
                    return-object
                    single-line
                    @change="get_all_info"
                ></v-select>
                  </v-flex> -->
        <v-flex xs12 sm6 md4>
          <v-select
            v-model="select_bank"
            :items="banks"
            item-text="name"
            item-value="id"
            label="  أختر البنك من"
            persistent-hint
            return-object
            single-line
            @change="get_bank"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            disabled
            v-model="select_bank.rasid"
            type="number"
            label="الرصيد"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-select
            v-model="select_bank2"
            :items="banks"
            item-text="name"
            item-value="id"
            label="  أختر البنك الي"
            persistent-hint
            return-object
            single-line
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            v-model="money"
            type="number"
            label="المبلغ"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm10 md10>
          <v-textarea v-model="comment" rows="2" label="ملاحظات"></v-textarea>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog2"
            v-model="modal2"
            :return-value.sync="date2"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date2"
                label=" التاريخ اليدوي"
                readonly
                outline
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date2" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialog2.save(date2)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-btn @click="add_BankTransfer">تحويل</v-btn>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        v-if="fatworas.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.price_after }}</td>
          <td class="text-xs-right">{{ props.item.remain }}</td>
          <td class="text-xs-right">{{ props.item.sdad_status }}</td>
          <td class="text-xs-right">{{ props.item.sdad_type_name }}</td>
          <td class="text-xs-right">{{ props.item.taslim_date }}</td>
          <td class="text-xs-right">{{ props.item.madionia_now }}</td>
          <td class="text-xs-right">
            <v-text-field
              v-model="props.item.money"
              type="number"
              @keyup.enter="add_khasm(props.item)"
            ></v-text-field>
          </td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير غير مسددة</div>
    </v-container>
  </div>
</template>

<script>
import {
  clients,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  banks,
  bank,
  bank_fatworas,
  add_BankTransfer,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " الكود",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: " السعر", value: "address", sortable: false, align: "right" },
      { text: " المتبقي", value: "address", sortable: false, align: "right" },
      { text: " حالة السداد", value: "rasid", sortable: false, align: "right" },
      { text: " نوع السداد", value: "rasid", sortable: false, align: "right" },
      {
        text: "تاريخ التسليم",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: "المديونية وقتها ",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: " مبلغ الخصم ",
        value: "control",
        sortable: false,
        align: "center"
      }
    ],
    select_client: { id: "" },
    select_bank: { id: "" },
    select_bank2: { id: "" },
    search: "",
    comment: "",
    loading: true,
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    bank_fatworas: [],
    clients: [],
    fatworas: [],
    banks: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theBank: {},
    money: "",
    searchClientCode: "",
    madionia_sabqa: "",
    madionia_sabqa_of_madionia: "",

    bank_fatwora_table1: {
      code: "",
      emp_name: "",
      rasid_before: "",
      money: "",
      rasid_after: "",
      type: "",
      notes: "",
      bank_id: "",
      created_at: ""
    },
    bank_fatwora_table2: {
      code: "",
      emp_name: "",
      rasid_before: "",
      money: "",
      rasid_after: "",
      type: "",
      notes: "",
      bank_id: "",
      created_at: ""
    },

    bank1: {
      id: "",
      rasid: ""
    },
    bank2: {
      id: "",
      rasid: ""
    }
  }),

  computed: {
    mycode() {
      if (this.bank_fatworas.length > 0) {
        return (this.code =
          parseInt(this.bank_fatworas[this.bank_fatworas.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      clients().then(response => {
        this.clients = response.data;
        this.loading = false;
      });

      let myUser = JSON.parse(localStorage.getItem("user"));
      banks(myUser.branch_id).then(response => {
        this.banks = response.data;
      });

      bank_fatworas().then(response => {
        this.bank_fatworas = response.data;
      });
    },

    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_client = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_client.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_client.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_client.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? response.data.client.rasid_efttahi != ""
              ? parseFloat(response.data.client.rasid_efttahi)
              : 0
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_bank() {
      bank(this.select_bank.id).then(response => {
        this.theBank = response.data;
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    add_BankTransfer() {
      let myUser = JSON.parse(localStorage.getItem("user"));

      this.bank_fatwora_table1.code = this.mycode;
      this.bank_fatwora_table1.emp_name = myUser.name;
      this.bank_fatwora_table1.rasid_before = this.select_bank.rasid;
      this.bank_fatwora_table1.money = this.money;
      this.bank_fatwora_table1.rasid_after = parseFloat(this.money);
      this.bank_fatwora_table1.type = "out";
      this.bank_fatwora_table1.notes = this.comment;
      this.bank_fatwora_table1.bank_id = this.select_bank.id;
      this.bank_fatwora_table1.created_at = this.date2;

      let bank_fatwora_1 = JSON.stringify(this.bank_fatwora_table1);

      this.bank_fatwora_table2.code = this.mycode + 1;
      this.bank_fatwora_table2.emp_name = myUser.name;
      this.bank_fatwora_table2.rasid_before = this.select_bank2.rasid;
      this.bank_fatwora_table2.money = this.money;
      this.bank_fatwora_table2.rasid_after = parseFloat(this.money);
      this.bank_fatwora_table2.type = "in";
      this.bank_fatwora_table2.notes = this.comment;
      this.bank_fatwora_table2.bank_id = this.select_bank2.id;
      this.bank_fatwora_table2.created_at = this.date2;

      let bank_fatwora_2 = JSON.stringify(this.bank_fatwora_table2);

      this.bank1.id = this.select_bank.id;
      this.bank1.rasid = this.money;
      let bank_1 = JSON.stringify(this.bank1);

      this.bank2.id = this.select_bank2.id;
      this.bank2.rasid = this.money;
      let bank_2 = JSON.stringify(this.bank2);

      this.do_deposit(bank_fatwora_1, bank_fatwora_2, bank_1, bank_2);
    },
    do_deposit(bank_fatwora_1, bank_fatwora_2, bank_1, bank_2) {
      this.loading = true;
      var frmData = new FormData();
      frmData.append("bank1", bank_1);
      frmData.append("bank2", bank_2);
      frmData.append("bank_fatwora_1", bank_fatwora_1);
      frmData.append("bank_fatwora_2", bank_fatwora_2);
      add_BankTransfer(frmData).then(response => {
        this.$router.go(0);
        var frmData3 = new FormData();
        frmData3.append("title", "عمل تحويل من بنك لبنك");
        frmData3.append(
          "body",
          "تم عمل تحويل من بنك   " +
            this.select_bank.name +
            " لبنك " +
            this.select_bank2.name +
            " مبلغ " +
            this.money +
            " بواسطة " +
            this.user.name
        );
        frmData3.append("type", "bank_withdrew");
        frmData3.append("user_id", this.user.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = "عمل تحويل من بنك لبنك";
            let mybody =
              "تم عمل تحويل من بنك   " +
              this.select_bank.name +
              " لبنك " +
              this.select_bank2.name +
              " مبلغ " +
              this.money +
              " بواسطة " +
              this.user.name;
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
          }
        });
        this.loading = false;
      });
    },
    push_client_sadad(sadad) {
      this.all_client_sadads.push(sadad);
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
